import { render } from "./TextEdit.vue?vue&type=template&id=2a3a3d22&scoped=true"
import script from "./TextEdit.vue?vue&type=script&lang=js"
export * from "./TextEdit.vue?vue&type=script&lang=js"

import "./TextEdit.vue?vue&type=style&index=0&id=2a3a3d22&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3a3d22"]])

export default __exports__